export enum ADDRESS_EDITING_STATUS {
  UPDATE = 'UPDATE',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
}
